import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesHeartFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1c6.563 0 7.5.875 7.5 7q0 .462-.01.885a2.9 2.9 0 0 0-.822-.365 2.98 2.98 0 0 0-2.267.304 3 3 0 0 0-2.255-.338c-1.216.307-2.149 1.389-2.149 2.8 0 1.249.831 2.159 1.464 2.707a11 11 0 0 0 1.266.921C9.949 14.976 9.046 15 8 15 1.438 15 .5 14.125.5 8S1.438 1 8 1M4 8.7h4.667V7.3H4zm0-2.667h8v-1.4H4z"
                fill="currentColor"
            />
            <path
                d="M9.397 11.285c0-1.5 1.909-2.147 3-.59 1.09-1.557 2.998-.834 2.999.59 0 1.062-1.264 1.953-2.41 2.656q-.248.152-.481.291l-.109.065-.107-.065-.085-.052c-1.229-.737-2.807-1.708-2.807-2.895"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesHeartFilledSize16Glyph.displayName = 'CardLinesHeartFilledSize16Glyph';
